module.exports = __webpack_public_path__ + "static/media/pic8.26fa1422.webp";